var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Login-page-wrap',{staticClass:"login-page",attrs:{"formTitle":_vm.formTitle}},[_c('register-form',{attrs:{"type":_vm.type}}),_c('UserAgreement',{attrs:{"autoRegTip":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }